import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // CRITICAL: if returning from OAuth callback, skip the /me check — AuthCallback exchanges the session_id first
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const onAuth = useCallback((data) => {
    setUser(data.user);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Logout request failed:", e?.message); }
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, loading, onAuth, logout }), [user, loading, onAuth, logout]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
